import { render, staticRenderFns } from "./tab11.vue?vue&type=template&id=36e0f4aa&scoped=true&"
import script from "./tab11.vue?vue&type=script&lang=js&"
export * from "./tab11.vue?vue&type=script&lang=js&"
import style0 from "./tab11.vue?vue&type=style&index=0&id=36e0f4aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e0f4aa",
  null
  
)

export default component.exports